import { useQuery } from '@apollo/client';

import { GetUserNeffiScoreDocument } from '@xing-com/crate-jobs-graphql';

import { getNeffiScoreStatus } from './get-neffi-score-status';
import type { NeffiStatus } from './types';

type UseGetUserNeffiScoreReturnValue = {
  normalizedNeffiScore: number;
  neffiStatus: NeffiStatus;
  isNeffiScoreLoading: boolean;
};

export const useGetUserNeffiScore = (
  isLoggedIn: boolean
): UseGetUserNeffiScoreReturnValue => {
  const { data, loading, error } = useQuery(GetUserNeffiScoreDocument, {
    variables: { consumer: 'loggedin.web.jobs.job_application.center' },
    skip: !isLoggedIn,
  });

  const score = data?.viewer?.networkEfficiencyIndicator?.score;
  const normalizedScore = score
    ? Math.round(score * 100)
    : score === 0
      ? 0
      : undefined;
  const neffiStatus: NeffiStatus = loading
    ? 'pending'
    : !normalizedScore || error
      ? 'failed'
      : getNeffiScoreStatus(normalizedScore);

  return {
    normalizedNeffiScore: normalizedScore ?? 0,
    neffiStatus,
    isNeffiScoreLoading: loading,
  };
};
